import React from "react";
import { connect } from "react-redux";
import { css } from "aphrodite";
import { style } from "./style";
import { withRouter } from "react-router-dom";
import DateFilter from "../../DateFilter";
import "./DiaryHeader.css";

class DiaryHeader extends React.Component {
  constructor(props) {
    super();
    this.state = {};
  }

  close = () => {
    this.props.resetEntity();
    this.props.history.push("/dashboard");
  };

  changeInterval = interval => {
    this.props.setInterval(interval);
  };

  setCustomSearchDate = (filterStartDate, filterEndDate) => {
    this.props.setCustomSearchDate(filterStartDate, filterEndDate);
  };

  render() {
    const { title } = this.props;
    return (
      <div className={`diary-header ${css(style.header)}`}>
        <div className="diary-header-inner">
          <div className="diary-header-title">{title}</div>
          <div className="diary-header-actions">
            <DateFilter
              changeInterval={(e) => this.changeInterval(e)}
              setCustomSearchDate={this.props.setCareTrendSearchDates}
              interval={this.props.interval}
            />
            <button
              type="button"
              className="diary-header-close"
              title="Close"
              onClick={this.close}
            >
              <img alt="close" src="/images/close_icon.png" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (store) => {
    return {
      interval: store.diary.interval,
    };
  },
  (dispatch) => {
    return {
      setInterval: (interval) => {
        dispatch({
          type: "CHANGE_DATE_INTERVAL",
          payload: { interval },
        });
      },
      setCustomSearchDate: (filterStartDate, filterEndDate) => {
        dispatch({
          type: "CHANGE_CUSTOM_FILTER_DATE",
          payload: { isCustom: true, filterStartDate, filterEndDate },
        });
      },
      resetEntity: () => {
        dispatch({
          type: "RESET_ENTITY_DATA",
        });
      },
    };
  }
)(withRouter(DiaryHeader));
